import type { UserLightResponse } from "./user";

export type InventoryAudience = "internal" | "external";

export interface InventoryItemResponse {
  id: number;
  name: string;
  description: string;
  improvementNotes: string | null;
  githubUrl: string | null;
  deploymentLocation: string | null;
  audience: InventoryAudience;
  status: "under_review" | "taken_over" | "rejected" | "completed";
  rejectCause:
    | "not_interesting"
    | "duplicate"
    | "non_compliant"
    | "out_of_scope"
    | "insufficient_info"
    | "not_sustainable"
    | "other"
    | null;
  rejectNote: string | null;
  participants: UserLightResponse[];
  createdBy: UserLightResponse;
  createdAt: string;
  updatedBy: UserLightResponse | null;
  updatedAt: string;
}

export interface CreateInventoryItemRequest {
  name: string;
  description: string;
  improvementNotes?: string;
  githubUrl?: string;
  deploymentLocation?: string;
  audience: InventoryAudience;
  participantIds: string[];
  attachments?: File[];
}

export interface UpdateInventoryItemRequest {
  name?: string;
  description?: string;
  improvementNotes?: string;
  githubUrl?: string;
  deploymentLocation?: string;
  audience?: InventoryAudience;
  participantIds?: string[];
  status?: "under_review" | "taken_over" | "rejected" | "completed";
  rejectCause?: string;
  rejectNote?: string;
}

export function rejectCauseLabel(cause: string, t: (k: string) => string): string {
  const map: Record<string, string> = {
    not_interesting: t("inventory.rejectCauseNotInteresting"),
    duplicate: t("inventory.rejectCauseDuplicate"),
    non_compliant: t("inventory.rejectCauseNonCompliant"),
    out_of_scope: t("inventory.rejectCauseOutOfScope"),
    insufficient_info: t("inventory.rejectCauseInsufficientInfo"),
    not_sustainable: t("inventory.rejectCauseNotSustainable"),
    other: t("inventory.rejectCauseOther"),
  };
  return map[cause] ?? cause;
}

export function statusLabel(status: InventoryItemResponse["status"], t: (k: string) => string) {
  const map: Record<InventoryItemResponse["status"], string> = {
    under_review: t("inventory.statusUnderReview"),
    taken_over: t("inventory.statusTakenOver"),
    rejected: t("inventory.statusRejected"),
    completed: t("inventory.statusCompleted"),
  };
  return map[status];
}
